import React from 'react';
import Modal from 'components/Modal';

import FileViewer from './FileViewer';

export default class Viewer extends React.Component {
  onKeyDown = e => {
    switch (e.which || e.keyCode) {
      case 27:
        this.props.close();
        break;
    }
  };

  componentDidMount = () => {
    document.addEventListener('keydown', this.onKeyDown);
  };

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.onKeyDown);
  };

  render() {
    const { files, show, activeIndex, close } = this.props;

    return show ? (
      <Modal show backdrop={false} dialogComponentClass="div" class="modal file-viewer show">
        {files.length ? <FileViewer activeIndex={activeIndex} files={files} /> : 'No files to show'}
        <div class="close-button" onClick={() => close()} />
      </Modal>
    ) : null;
  }
}
Viewer.defaultProps = {
  showIndex: false,
  activeIndex: 0,
  show: false,
  close: () => {},
};

/*{files.length ? (
  <FileViewer
    activeIndex={activeIndex}
    files={files}
    />
) : "No files to show"}
<div class="close-button" onClick={() => close()} />*/
